<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Partner Contract Info
    </div>
    <div class="enterprise-network_container_content">
      <el-form ref="form" :model="formData" :rules="rules" label-position="top" :disabled="!isSeniorEditor">
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="partnerType">
            <template #label>
              <div class="enterprise-network-label_required">Partner Type</div>
            </template>
            <el-select v-model="formData.partnerType" @change="handleChangePartnerType">
              <el-option
                v-for="item in partnerTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="signingAgreementPartyA" v-if="isEBG && !isRcp">
            <template #label>
              <div class="enterprise-network-label_required">
                Party A of the Signing Agreement
              </div>
            </template>
            <el-select v-model="formData.signingAgreementPartyA">
              <el-option
                v-for="item in signingAgreementPartyAList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="parentCompanyCode" v-if="isRcp">
            <template #label>
              <div class="smbsales-label_required">
                Affiliated RAD
              </div>
            </template>
            <el-select
              v-model="formData.parentCompanyCode"
              filterable
              clearable
              remote
              :remote-method="searchEBGType"
              @change="handleVADTypeChange"
            >
              <el-option
                v-for="(item, index) in vadTypeList"
                :key="item.companyCode + index"
                :label="item.companyName"
                :value="item.companyCode"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="contractValidity" v-if="!isEBG">
            <template #label>
              <div class="enterprise-network-label_required">
                Contract Expiry Date
              </div>
            </template>
            <el-date-picker
              v-model="formData.contractValidity"
              type="date"
              placeholder="Select date"
              value-format="yyyy-MM-dd"
              @change="handleChangeContractExpiryDate"
              :picker-options="{
                disabledDate
              }"
            />
          </el-form-item>
        </div>
        <template v-if="isEBG && isRcp">
          <div class="enterprise-network_grid grid-1x2 gap_80">
            <el-form-item prop="partnerPaymentTerms" v-if="isEBG && !isRcp">
              <template #label>
                <div class="enterprise-network-label_required">
                  Partner Payment Terms
                </div>
              </template>
              <el-radio-group v-model="formData.partnerPaymentTerms">
                <el-radio :label="0"> Cash</el-radio>
                <el-radio :label="1"> Credit</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="contractStartDate" v-if="isEBG && isRcp">
              <template #label>
                <div class="enterprise-network-label_required">
                  Contract Start Date
                </div>
              </template>
              <el-date-picker
                v-model="formData.contractStartDate"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item prop="contractValidity" v-if="isRcp">
              <template #label>
                <div class="enterprise-network-label_required">
                  Contract Expiry Date
                </div>
              </template>
              <el-date-picker
                v-model="formData.contractValidity"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
                @change="handleChangeContractExpiryDate"
                :picker-options="{
                  disabledDate
                }"
              />
            </el-form-item>
          </div>
          <div class="enterprise-network_grid grid-1x2 gap_80" v-if="!isRcp">
            <el-form-item prop="contractValidity">
              <template #label>
                <div class="enterprise-network-label_required">
                  Contract Expiry Date
                </div>
              </template>
              <el-date-picker
                v-model="formData.contractValidity"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
                @change="handleChangeContractExpiryDate"
                :picker-options="{
                  disabledDate
                }"
              />
            </el-form-item>
            <el-form-item prop="parentCompanyCode" v-if="isShowVadSelect && !isRcp">
              <template #label>
                <div class="smbsales-label_required">
                  Affiliated RAD
                </div>
              </template>
              <el-select
                v-model="formData.parentCompanyCode"
                filterable
                clearable
                remote
                :remote-method="searchEBGType"
                @change="handleVADTypeChange"
              >
                <el-option
                  v-for="(item, index) in vadTypeList"
                  :key="item.companyCode + index"
                  :label="item.companyName"
                  :value="item.companyCode"
                />
             </el-select>
           </el-form-item>
          </div>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  findListByName, getAllPartnerTypes,
  getPartnerType,
  getSysBaseConfigList,
  getEBGAffiliatedist
} from "../../../../api/international";
import dayjs from "dayjs";
export default {
  name: "enterpriseNetworkPartnerContractInfoEdit",
  emits: ['changePartnerType', 'changeContractExpiryDate'],
  props: {
    // 1 SBG/2 EBG/3 CBG互联网/4 TBU运营商 默认2, 1属于上期的东西本期不兼容
    partnerModeType: {
      type: [Number, String],
      default: 2
    },
    partnerType: {
      type: String,
      default: ''
    },
    isSeniorEditor: {
      type: Boolean,
      default: false
    },
    isApply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      a:0,
      formData: {
        partnerType: void 0, // RAD RAP RSP
        partnerTypeName: void 0,
        signingAgreementPartyA: 'Ruijie Networks Co., Ltd', //初始化参数 默认第一个
        partnerPaymentTerms: 0,
        contractStartDate: void 0,
        contractValidity: void 0,
        // 上级渠道id
        parentCompanyCode: "",
        parentCompanyName: "",
      },
      vadTypeList: [], // AffiliatedVAD 选择数据源
      partnerTypeList: [],
      signingAgreementPartyAList: []
    };
  },
  watch: {
    partnerModeType(){
      this.getPartnerTypeList()
    }
  },
  computed: {
    ...mapState("smbSales", ["partnerContractInfo", "selectCountryAndRegion"]),
    rules() {
      return {
        partnerType: [
          {
            required: true,
            message: "Please select partner type",
            trigger: "change"
          }
        ],
        signingAgreementPartyACode: [
          {
            required: this.isEBG,
            message: "Please select party A of the signing agreement",
            trigger: "change"
          }
        ],
        partnerPaymentTerms: [
          {
            required: this.isEBG,
            message: "Please select partner payment terms",
            trigger: "change"
          }
        ],
        contractStartDate: [
          {
            required: this.isEBG,
            message: "Please select contract start date",
            trigger: "change"
          }
        ],
        contractValidity: [
          {
            required: true,
            message: "Please select contract expiry date",
            trigger: "change"
          }
        ]
      };
    },
    isEBG() {
      console.log(this.partnerModeType, 'partnerModeType');
      return Number(this.partnerModeType) === 2
    },
    isShowVadSelect() {
      return this.isEBG && ["RGP","RSP","RCP"].includes(this.formData.partnerType)
    },
    isRcp() {
      return this.partnerType === 'RCP'
    }
  },
  methods: {
    // 当所属VAD更改的时候
    handleVADTypeChange(code) {
      // console.log(code, 888);
      const vadTypeInfo = this.vadTypeList.find(
        item => item.companyCode === code
      );
      this.formData.parentCompanyName = vadTypeInfo.companyName;
    },
    searchEBGType(searchValue) {
      let country = this.selectCountryAndRegion.country;
      let params = {
        companyName: searchValue,
        documentId: this.$route.query.documentId || void 0
      }
      getEBGAffiliatedist(params)
        .then(res => {
          let { status, data } = res
          // console.log(data,8888);
          if (Number(status) === 200) {
            this.vadTypeList = data || []
            // 没搜索出来清空值 code 和 name ,便于 编辑或者续签的时候 防止选择到过期的
            if (data && data.length < 1) {
              this.formData.parentCompanyCode = ''
              this.formData.parentCompanyName = ''
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPartnerTypeList() {
      getPartnerType(this.partnerModeType).then(response => {
        let {status, data} = response;
        if (Number(status) === 200) {
          if(this.isApply&&this.$route.query.partnertype==="RCP"&&data){
            data.forEach((item, ind) => {
              if(item.code=="RCP"){
                this.partnerTypeList.push(data[ind])
              }
            });
          }else{
            this.partnerTypeList = data || [];
          }
          
        }
      });
    },
    setFormData(formData) {
      if (!formData) return;
      this.formData = JSON.parse(JSON.stringify(formData));
      // 回显Affiliated RAD
      if (['RCP', 'RSP', 'RGP'].includes(formData.partnerType) && formData.parentCompanyName) {
        this.searchEBGType(formData.parentCompanyName)
      }
    },
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(valid => {
        isPass = valid;
      });
      if (!isPass) return;
      // 企业网直接返回全部
      if (this.isEBG) {
        if (this.isRcp) {
          return {
            partnerType: this.formData.partnerType,
            partnerTypeName: this.partnerTypeList.find(item => item.code === this.formData.partnerType).name,
            parentCompanyCode: this.formData.parentCompanyCode,
            parentCompanyName: this.formData.parentCompanyName,
            contractStartDate: this.formData.contractStartDate, 
            contractValidity: this.formData.contractValidity,
          };
        }else {
          return {
            ...JSON.parse(JSON.stringify(this.formData)),
            partnerTypeName: this.partnerTypeList.find(item => item.code === this.formData.partnerType).name
          };
        }
      }else {
        // 否则返回渠道类型和到期时间
        return {
          partnerType: this.formData.partnerType,
          partnerTypeName: this.formData.partnerTypeName,
          contractValidity: this.formData.contractValidity
        }
      }

    },
    getSigningAgreementPartyAList() {
      findListByName("SIGNING_AGREEMENT_PARTY_A")
        .then(response => {
          let {status, data} = response;
          if (Number(status) === 200) {
            this.signingAgreementPartyAList = data || [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    disabledDate(time) {
      let nowData = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(time).format("YYYY-MM-DD");
      // 今天之前的日期不可选
      if (dayjs(currentDate).isBefore(dayjs(nowData))) {
        return true;
      }
      // 如果今天不是12月， 那么不可选择第二年第一天之后的日期
      if (dayjs(nowData).month() !== 11) {
        if (
          dayjs(currentDate).isAfter(dayjs(dayjs(nowData).format("YYYY-12-31")))
        ) {
          return true;
        }
      } else {
        // 如果今天是12月， 那么不可选择第二年最后一天的之后的日期
        if (
          dayjs(currentDate).isAfter(
            dayjs(
              dayjs(nowData)
                .add(1, "year")
                .format("YYYY-12-31")
            )
          )
        ) {
          return true;
        }
      }
    },
    // 设置默认的合同到期时间
    setContractValidity() {
      this.formData.contractStartDate = dayjs().format("YYYY-MM-DD")
      this.formData.contractValidity = dayjs().month() === 11
        ? dayjs()
          .add(1, "year")
          .format("YYYY-12-31")
        : dayjs().format("YYYY-12-31")
      this.handleChangeContractExpiryDate(this.formData.contractValidity);
    },
    handleChangePartnerType(partnerType) {
      this.$emit('changePartnerType', partnerType);
    },
    handleChangeContractExpiryDate(contractExpiryDate) {
      this.$emit('changeContractExpiryDate', contractExpiryDate);
    },
  },
  mounted() {
    this.getPartnerTypeList();
    this.getSigningAgreementPartyAList();
    this.formData.partnerType = this.$route.query.partnertype || void 0;
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/partnerContractInfo/partnerContractInfoEdit.vue